import React from 'react'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { Footer } from '@/organisms/Footer'
import { SiteNav } from '@/organisms/SiteNav'
import { BaseLayout } from '../BaseLayout'

interface DefaultLayoutProps {
  children: React.ReactNode
}

export const PIFExplainerLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  return (
    <BaseLayout isDarkMode={true}>
      <SiteNav gradientBackground />
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
      <Footer />
    </BaseLayout>
  )
}
